(function () {

    const mcsElements = document.querySelectorAll(".mcs")

    function viewport() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width: e[a + 'Width'], height: e[a + 'Height'] };
    }

    function repositionImg() {

        mcsElements.forEach(mcs => {
            const imgElement = mcs.querySelector("img")
            const formElement = mcs.querySelector(".mcs-form")
            const currentImgParent = imgElement.parentElement
            const heading = mcs.querySelector(".heading")
            const width = viewport().width
            if (width < 768) {
                if (!currentImgParent.classList.contains("mcs")) {
                    imgElement.remove()
                    mcs.insertBefore(imgElement, formElement)
                }
            } else {
                if (currentImgParent.classList.contains("mcs")) {
                    imgElement.remove()
                    formElement.appendChild(imgElement)
                }
            }
        })
    }


    window.addEventListener("resize", () => {
        repositionImg();
    })

    repositionImg()
})();